export { BankDetailsChange } from '@libs/selfService-request/config';

export enum BankDetailsChangePaymentKind {
  MAIN = 'MAIN',
}

export enum BankDetailsChangePaymentMethod {
  BANK_TRANSFER = 'BANK_TRANSFER',
  POSTAL = 'POSTAL',
}
